import React from 'react';
import GolfLoginTemplate from '../components/template/golfLoginTemplete';
import store from '..';
class GolfLogin extends React.Component{
    
    render(){
        return(
            <div>
                <GolfLoginTemplate/>
            </div>
        )
    }
}
export default GolfLogin;